
import {
  UserRole, Contact, Task, Document, Attendance
} from './types';

export const defaultContactCategories: string[] = [
  'Cidadão', 'Entidade', 'Imprensa', 'Órgão', 'Fornecedor', 'Liderança Regional'
];

export const defaultDocumentThemes: string[] = [
  'Saúde', 'Educação', 'Segurança', 'Infraestrutura', 'Zeladoria',
  'Meio Ambiente', 'Transporte', 'Cultura', 'Assistência Social', 'Esporte'
];

export const defaultDocumentTypes: string[] = [
  'Ofício', 
  'Requerimento', 
  'Indicação', 
  'Projeto de Lei', 
  'Requerimento de Informação', 
  'Representação Judicial', 
  'Lei de Acesso à Informação',
  'Outros'
];

// Dados Mock removidos para evitar conflito com tipos UUID do banco
export const mockUsers: any[] = [];
export const mockContacts: Contact[] = [];
export const mockTasks: Task[] = [];
export const mockDocuments: Document[] = [];
export const mockAttendances: Attendance[] = [];
export const mockAmendments: any[] = [];
export const mockBills: any[] = [];
